import React, { useContext } from "react";
import { AppContext } from "../util/AppContext";
import { getConfigValue, isBatchPrintEnabledForAnyProduct } from '../util/getConfigValue';
import LeaderboardPage from './leaderboardPage';
import QuickSheetsPage from './quickSheetsPage'
import RecentSalesAidsPage from './recentSalesAidsPage';
import FocusPage from "./focusPage";
import HCPPage from "./hcpPage";
import TerritoryPage from "./territoryPage";
import AnouncementsCard from "../components/leaderboard/AnnouncementsCard";

function HomePage() {
    const [appState] = useContext(AppContext);
    const batchPrintEnabled = isBatchPrintEnabledForAnyProduct(appState);
    const salesAidGenerationEnabled = !appState.configLoaded ? false : getConfigValue(appState?.config?.Sellsheet?.Generation?.Enabled, appState)?.Value === 'true' || false;
    const leaderBoardEnabled = !appState.configLoaded ? false : getConfigValue(appState?.config?.Leaderboard?.Enabled, appState)?.Value === 'true' || false;
    const quickSheetsEnabled = !appState.configLoaded ? false : getConfigValue(appState?.config?.QuickSheets?.Enabled, appState)?.Value === 'true' || false;

    const defaultHomePage = !appState.configLoaded ? false : getConfigValue(appState?.config?.DefaultHomePage, appState)?.Value?.toLowerCase() || "recentsalesaidspage";
    const isLoggedIn = appState.user !== undefined && appState.user !== '';
     
    const getHomePage = () => {     

        switch (defaultHomePage.toLowerCase()) {
            case 'leaderboardpage':
                if (isLoggedIn && leaderBoardEnabled) return <LeaderboardPage />;
                break;
            case "recentsalesaidspage":
                if (isLoggedIn && salesAidGenerationEnabled) return <RecentSalesAidsPage />;
                break;
            case "quicksheetspage":
                if (isLoggedIn && quickSheetsEnabled) return <QuickSheetsPage />
                break;
            case "createsalesaid":
                if (isLoggedIn && (salesAidGenerationEnabled && batchPrintEnabled)) return <FocusPage />
                if (isLoggedIn && (salesAidGenerationEnabled && !batchPrintEnabled)) {
                    if (appState?.bypassTerritorySelection) {
                        return <HCPPage />
                    } else {
                        return <TerritoryPage />
                    }
                }
                break;
        }

        return <RecentSalesAidsPage />;
    }

    return (
        <>
            <div className='container-xl mt-4'>
                <AnouncementsCard />
            </div>

            {getHomePage()}
        </>
    )
}

export default HomePage